import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { FormulasCategoryCountModel } from '../../models/formula.model';

// services
import API from '../../services/api';

import formulaKeys from './_queryKeys';

const getFormulasCategoryCount = async (
    includeControlledFormula?: boolean,
): Promise<FormulasCategoryCountModel> => {
    const { data } = await API.fetchFormulasCategoryCount({
        include_controlled_formula: includeControlledFormula,
    });
    return data;
};

export default function useFormulasCategoryCountQuery(
    includeControlledFormula?: boolean,
) {
    return useQuery<FormulasCategoryCountModel, BaseError>({
        queryKey: formulaKeys.formulaCatalogCount(includeControlledFormula),
        queryFn: () => getFormulasCategoryCount(includeControlledFormula),
        staleTime: 60000,
    });
}
